"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingPictureRenderer = void 0;
var tslib_1 = require("tslib");
var renderer_class_names_1 = require("../../../../core/canvas/renderer-class-names");
var dom_1 = require("@devexpress/utils/lib/utils/dom");
var number_1 = require("@devexpress/utils/lib/utils/map/number");
var base_renderer_1 = require("./base-renderer");
var FloatingPictureRenderer = (function (_super) {
    tslib_1.__extends(FloatingPictureRenderer, _super);
    function FloatingPictureRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FloatingPictureRenderer.prototype.handlePageHide = function (_pageIndex) {
        return true;
    };
    FloatingPictureRenderer.prototype.handlePageRender = function (pageIndex, _force) {
        var _this = this;
        var cacheElement = this.renderer.cache[pageIndex];
        var layoutPage = this.renderer.layout.pages[pageIndex];
        if (!cacheElement || !layoutPage)
            return false;
        var subDocumentId = this.newSubDocumentInfo.subDocumentId;
        number_1.NumberMapUtils.forEach(cacheElement.anchoredPicture, function (ancPicNode, picId) {
            var belongsTo = layoutPage.anchoredObjectHolder.getObjById(picId).belongsToSubDocId;
            if (belongsTo == subDocumentId ||
                (_this.newSubDocumentInfo.isTextBox && _this.newSubDocumentInfo.parentSubDocumentId == belongsTo))
                dom_1.DomUtils.removeClassName(ancPicNode, renderer_class_names_1.RendererClassNames.BLACKOUT);
            else
                dom_1.DomUtils.addClassName(ancPicNode, renderer_class_names_1.RendererClassNames.BLACKOUT);
        });
        return true;
    };
    return FloatingPictureRenderer;
}(base_renderer_1.BaseRenderer));
exports.FloatingPictureRenderer = FloatingPictureRenderer;
